<div class="modal-header">
    <h4 class="modal-title">Exportar diagramaciones</h4>
    <div class="selection-counter" *ngIf="selection.hasValue()">
        {{selection.selected.length}} seleccionada(s)
    </div>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content class="mat-typography export-dialog-content">
    <div class="export-header">
        <div class="row">
            <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Buscar</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Buscar diagramación..." #input>
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Proyectos</mat-label>
                    <mat-select multiple [value]="selectedProjects" (selectionChange)="applyProjectFilter($event.value)" placeholder="Selecciona proyectos">
                        <button type="button" mat-flat-button (click)="toggleAllProjects()" [disabled]="!projects.length">
                            <mat-icon>library_add</mat-icon>
                            {{ areAllProjectsSelected() ? 'Quitar todos' : 'Seleccionar todos' }}
                        </button>
                        <mat-option *ngFor="let project of projects" [value]="project">{{ project }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <p>Selecciona las diagramaciones que deseas exportar. El listado incluye las diagramaciones correspondientes a todos los proyectos de la campaña actual.</p>
        </div>
    </div>
    <div class="export-table-container">
        <div class="table-responsive ">
            <table mat-table [dataSource]="dataSource" matSort class="w-100">

                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                                      [checked]="selection.hasValue() && isAllSelected()"
                                      [disabled]="dataSource.filteredData.length === 0"
                                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="$event ? selection.toggle(row) : null"
                                      [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                    <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                </ng-container>

                <!-- Columns -->
                <ng-container matColumnDef="alias">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Alias </th>
                    <td mat-cell *matCellDef="let row"> {{row.alias}} </td>
                </ng-container>

                <ng-container matColumnDef="medio">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Medio </th>
                    <td mat-cell *matCellDef="let row"> {{row.medio}} </td>
                </ng-container>

                <ng-container matColumnDef="pop">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> POP </th>
                    <td mat-cell *matCellDef="let row"> {{row.pop}} </td>
                </ng-container>

                <ng-container matColumnDef="posicion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Posición </th>
                    <td mat-cell *matCellDef="let row"> {{row.posicion}} </td>
                </ng-container>

                <ng-container matColumnDef="cant_sucursales">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Sucursales </th>
                    <td mat-cell *matCellDef="let row" class="text-center"> {{row.cant_sucursales}} </td>
                </ng-container>

                <ng-container matColumnDef="cantidad">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Cantidad </th>
                    <td mat-cell *matCellDef="let row" class="text-center"> {{row.cantidad}} </td>
                </ng-container>

                <ng-container matColumnDef="nombre_proyecto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Proyecto </th>
                    <td mat-cell *matCellDef="let row" class="text-center"> {{row.nombre_proyecto}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell text-center p-3" [attr.colspan]="displayedColumns.length" *ngIf="input.value; else noData">
                        No se encontraron resultados para "{{ input.value }}".
                    </td>
                    <ng-template #noData>
                        <td class="mat-cell text-center p-3" [attr.colspan]="displayedColumns.length">
                            No hay diagramaciones disponibles.
                        </td>
                    </ng-template>
                </tr>
            </table>
            <mat-paginator [pageSizeOptions]="[10, 25, 100]" [length]="dataSource.data.length" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cancelar</button>&nbsp;
    <button mat-raised-button color="primary" (click)="exportDiagramaciones()" [disabled]="selection.isEmpty()">
        <mat-icon>open_in_new</mat-icon> Exportar
    </button>
</mat-dialog-actions>
